import { render, staticRenderFns } from "./EquipamentoConfiguracaoTab.vue?vue&type=template&id=288a5440&scoped=true&"
import script from "./EquipamentoConfiguracaoTab.vue?vue&type=script&lang=js&"
export * from "./EquipamentoConfiguracaoTab.vue?vue&type=script&lang=js&"
import style0 from "./EquipamentoConfiguracaoTab.vue?vue&type=style&index=0&id=288a5440&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288a5440",
  null
  
)

export default component.exports